import { gql } from '@apollo/client';

export const GET_ASSETS_FOR_USER = gql`
  query GetAssetsForUser($userId: String!) {
    getAssetsForUser(userId: $userId) {
      id
      tag
      uploadedDate
      metadata
      key
      userId
      url
      tenantId
      status
    }
  }
`;

export const GET_ASSET_TEMPLATES_FOR_TENANT = gql`
  query GetAssetTemplatesForTenant($tenantId: String!) {
    getAssetTemplatesForTenant(tenantId: $tenantId) {
      id
      tag
      isRequired
      title
      description
      usesExpiresAt
      usesIssuedAt
      expiryLength
      tenantId
    }
  }
`;
